// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31fIc","signatureBlock":"Footer_signatureBlock__1qKwk","signature":"Footer_signature__11nCX"};